import React from 'react';
import { Side } from '../nav/Side';
import { FormattedIcon } from '../icon/formattedIcon';
import {socialMedia} from '../../utils/socialmedia';

// import styled
import { StyledLink, StyledList } from './Social_styled';

export const Social = () => (
  <Side orientation="left">
    <StyledList>
             <StyledLink
              href={socialMedia.github}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Github">
              <FormattedIcon name="GitHub" />
            </StyledLink>

           
            <StyledLink
              href={socialMedia.twitter}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Twitter">
              <FormattedIcon name="Twitter" />
            </StyledLink>

            <StyledLink
              href={socialMedia.linkedin}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Linkedin">
              <FormattedIcon name="Linkedin" />
            </StyledLink>

            <StyledLink
              href={socialMedia.instagram}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Instagram">
              <FormattedIcon name="Instagram" />
            </StyledLink>

            <StyledLink
              href={socialMedia.facebook}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Instagram">
              <FormattedIcon name="Facebook" />
            </StyledLink>

            <StyledLink
              href={socialMedia.skype}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Instagram">
              <FormattedIcon name="Skype" />
            </StyledLink>

            <StyledLink
              href={socialMedia.telegram}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Instagram">
              <FormattedIcon name="Telegram" />
            </StyledLink>
         
    </StyledList>
  </Side>
);



export default Social;
